<template>
  <SolutionPageLayout title="Conferences & Seminars" section="Type">
    <p>
      Conferences live or die on programme quality, networking, and a smooth delegate experience from first registration to the closing session.
    </p>
    <p>
      Entegy brings together schedules, speaker portals, audience participation, and communications—so delegates stay informed and organisers stay in control.
    </p>
  </SolutionPageLayout>
</template>

<script setup>
import SolutionPageLayout from './SolutionPageLayout.vue'
</script>
